import React from "react";
import {
  StyledSection,
  HeroContainer,
  BackgroundImage,
  BlurOverlay,
  ContentWrapper,
  TextContent,
  HeaderTitle,
  HeaderSubtitle,
  TitleContainer,
} from "./styles";
import { DecorativeDot } from "../../../lib/styles";
import {
  HOMEPAGE_ANCHOR_CONTAINER_IDs,
  MOBILE_BREAKPOINT,
} from "../../../lib/constants";
import { useMediaQuery } from "react-responsive";
import TitleCard from "./TitleCard";
import Features from "./Features";

export function HeroSection() {
  const isMobile = useMediaQuery({ maxWidth: MOBILE_BREAKPOINT });

  return (
    <StyledSection id={HOMEPAGE_ANCHOR_CONTAINER_IDs.hero.key}>
      <HeroContainer>
        <BackgroundImage />
        <BlurOverlay />

        <ContentWrapper>
          <TitleContainer>
            <TextContent>
              <HeaderTitle>
                AI Powered Political Messaging <br />
                That Actually Works
                <DecorativeDot
                  src="/images/icons/dot-black.svg"
                  alt="Decorative dots"
                />
              </HeaderTitle>
              <HeaderSubtitle>
                Build Connections, Boost Fundraising, and Track Supporter
                Sentiment in Real Time.
              </HeaderSubtitle>
            </TextContent>

            <TitleCard />
          </TitleContainer>

          <Features isMobile={isMobile} />
        </ContentWrapper>
      </HeroContainer>
    </StyledSection>
  );
}
